import React from 'react';
import { Helmet } from 'react-helmet';
import TemplateFinder from '../Templates/TemplateFinder';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { VoucherPopup } from '../VoucherPopup';

function Content({
	entries: {
		items: [
			{
				fields: {
					section,
					promoCode,
					promoCodeANI,
					footerType,
					privacy,
					tC,
					voucherPopup,
					voucherPopupBanner,
					voucherPopupContent,
					enablePaypal,
					showCopyright,
					pageTitle,
				},
			},
		],
	},
	brandData,
}) {
	return (
		<>
			<Helmet>
				<title>
					{pageTitle ? pageTitle : 'Special Offer'} - {brandData?.name}
				</title>
			</Helmet>
			<Header brandData={brandData} />
			{section?.map(
				(
					{
						sys: {
							contentType: {
								sys: { id },
							},
						},
						fields,
					},
					index
				) => {
					return (
						<TemplateFinder key={index} component={id} restProps={fields} />
					);
				}
			)}
			<Footer
				brandData={brandData}
				promoCode={promoCode ?? promoCodeANI}
				footerType={footerType}
				privacyCopy={privacy}
				termsCopy={tC}
				enablePaypal={enablePaypal}
				showCopyright={showCopyright}
			/>
			{voucherPopup ? (
				<VoucherPopup
					brandData={brandData}
					banner={voucherPopupBanner}
					content={voucherPopupContent}
				/>
			) : null}
		</>
	);
}

export default Content;
